import { createContext, useState, useEffect } from "react";

export const LevelContext = createContext();

const LevelProvider = ({ children }) => {
  const fromLS = JSON.parse(localStorage.getItem("level"));

  const [level, setLevel] = useState(fromLS ? fromLS : "hard");

  useEffect(() => {
    localStorage.setItem("level", JSON.stringify(level));
  }, [level]);

  useEffect(() => {
    setLevel(JSON.parse(localStorage.getItem("level")));
  }, []);

  return (
    <LevelContext.Provider value={{ level, setLevel }}>
      {children}
    </LevelContext.Provider>
  );
};

export default LevelProvider;
